import { render, staticRenderFns } from "./FieldsOrderFormModal.vue?vue&type=template&id=22f0786c&scoped=true"
import script from "./FieldsOrderFormModal.vue?vue&type=script&lang=js"
export * from "./FieldsOrderFormModal.vue?vue&type=script&lang=js"
import style0 from "./FieldsOrderFormModal.vue?vue&type=style&index=0&id=22f0786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0786c",
  null
  
)

export default component.exports